// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getPageLinkByNodeId } from "@eisinc/App/Store/Selectors/LinksSelectors";
import { HeaderMyAccountLinkModel } from "@eisinc/Overrides/Widgets/Common/HeaderSignIn";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export interface MyAccountLinkModel {
    isGroup?: boolean;
    url: string;
    excludeFromNavigation?: boolean;
    title: string;
    pageType?: string;
}

export const getAllowedLinks = (state: ApplicationState, links?: HeaderMyAccountLinkModel[]) =>
    (links || [])
        .map((linkItem: HeaderMyAccountLinkModel) => {
            const node = getPageLinkByNodeId(state, linkItem?.fields?.destination?.value);
            return {
                isGroup: linkItem.fields.isGroup,
                url: node?.url || "",
                excludeFromNavigation: node?.excludeFromNavigation,
                title: linkItem.fields.isGroup ? linkItem.fields.title : node?.title || "",
                pageType: node?.type,
            };
        })
        .filter(
            i =>
                ((!i.excludeFromNavigation || i.isGroup) && i.pageType !== "ChangeCustomerPage") ||
                (i.pageType === "ChangeCustomerPage" && state.context.session.displayChangeCustomerLink),
        );
